/**
 * Formats a transcript into sentences and makes sure that abbreviations are not split into sentences.
 */
export const toSentences = (transcript: string) => {
  return transcript.replace(
    /\b(Mr|Mrs|Ms|Miss|Jr|Dr|Doctor|Hi)(\.\s*)|([.!?]\s*)/g,
    (match, abbreviation) => (abbreviation ? match : match + '\n'),
  );
};
